import React from 'react';
import {
  Button,
  getRehydratableName,
  getClassNameFactory,
  Responsive,
} from '@dcl/ui';
import { propsToDataAttributes } from '@tr-digital/react-rehydrate';
import {
  ButtonKind,
  ButtonColor,
  IconPosition,
} from '@dcl/ui/dist/elements/Button';
import { IBrowseExperienceButtonProps } from './BrowseExperienceButton.types';
import { DESKTOP_WIDTH, MOBILE_WIDTH } from '../TermsAndConditions/constants';
import { BROWSE_ICON, ICON_LEFT } from './constants';
import BrowseIcon from './icons/BrowseIcon';
import './index.css';

export const BrowseExperienceButton: React.FC<IBrowseExperienceButtonProps> = (
  props
) => {
  const { icon, iconAlignment, label, path, isNewTab } = props;
  const getClassName = getClassNameFactory(BrowseExperienceButton.displayName);

  let buttonIcon: React.ReactNode = icon;
  if (icon === BROWSE_ICON) {
    buttonIcon = <BrowseIcon />;
  }

  return (
    <div
      data-rehydratable={getRehydratableName(
        BrowseExperienceButton.displayName
      )}
      {...propsToDataAttributes(props)}
      className={getClassName()}
    >
      <div />
      <div className={getClassName({ descendantName: 'btn' })}>
        <Responsive minWidth={DESKTOP_WIDTH}>
          <Button
            kind={ButtonKind.LINK}
            color={ButtonColor.TERTIARY}
            icon={buttonIcon}
            iconPosition={
              iconAlignment === ICON_LEFT
                ? IconPosition.LEFT
                : IconPosition.RIGHT
            }
            disabled={false}
            href={path}
            newWindow={isNewTab}
          >
            {label}
          </Button>
        </Responsive>
        <Responsive minWidth={0} maxWidth={MOBILE_WIDTH}>
          <Button
            kind={ButtonKind.LINK}
            color={ButtonColor.SECONDARY}
            icon={buttonIcon}
            iconPosition={
              iconAlignment === ICON_LEFT
                ? IconPosition.LEFT
                : IconPosition.RIGHT
            }
            disabled={false}
            href={path}
            newWindow={isNewTab}
            block
          >
            {label}
          </Button>
        </Responsive>
      </div>
    </div>
  );
};

BrowseExperienceButton.displayName = 'BrowseExperienceButton';
